import Repository from './Repository'
import { options } from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.pcmApi}/`
const resourceCrm = `${options.baseURL}/`

export default {
  async create(params) {
    const response = await Repository.post(`${resource}campaign`, params, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async getList(params) {
    const response = await Repository.get(`${resource}campaign`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getOptions(params) {
    const response = await Repository.get(`${resource}common/campaign`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getDetail(id) {
    const response = await Repository.get(`${resource}campaign/${id}`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async updateStatus(id, body) {
    const response = await Repository.patch(`${resource}campaign/${id}/status?status=${body.status}`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },

  async update(id, body) {
    const response = await Repository.put(`${resource}campaign/${id}`, body, {
      headers: TokenService.getHeader(),
    })
    return response
  },
}
